<template>
	<section class="reportByUserBox">
		<div class="titleBox">
			<i class="icon iconfont iconHome"></i> {{ localizedItemTxt }}
		</div>
		<chart-search reportKey="reportByUser"></chart-search>
		<report-table></report-table>
	</section>
</template>

<script>
	import { chartSearch } from '@/views/components';
	import reportTable from './reportTable';
	export default {
		components: {
			chartSearch,
			reportTable
		},
		computed: {
			localizedItemTxt() {
				return "叫车人统计";
			}
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.reportByUserBox {
		padding: 16px 16px 50px 16px;
		background-color: white;
		.titleBox {
			height: 60px;
			line-height: 60px;
			font-size: 18px;
			.iconHome {
				color: #409eff;
				font-size: 30px;
			}
		}
	}
</style>